// this is src/components/DateFilterButtons.js
import React from 'react';
import './DateFilterButtons.css';

export const PERIOD_CONFIG = {
  '1W': { label: '1W', days: 7, candleGranularity: 'daily', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '1M': { label: '1M', days: 30, candleGranularity: 'daily', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '3M': { label: '3M', days: 90, candleGranularity: 'weekly', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '6M': { label: '6M', days: 180, candleGranularity: 'weekly', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '1Y': { label: '1Y', days: 365, candleGranularity: 'monthly', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '2Y': { label: '2Y', days: 730, candleGranularity: 'monthly', downsampleForNonCandles: false, showYearsOnXAxis: false },
  '3Y': { label: '3Y', days: 1095, candleGranularity: 'monthly', downsampleForNonCandles: true, showYearsOnXAxis: true },
  '4Y': { label: '4Y', days: 1460, candleGranularity: 'monthly', downsampleForNonCandles: true, showYearsOnXAxis: true },
  '5Y': { label: '5Y', days: 1825, candleGranularity: 'yearly', downsampleForNonCandles: true, showYearsOnXAxis: true },
  MAX: { label: 'MAX', days: null, candleGranularity: 'daily', downsampleForNonCandles: false, showYearsOnXAxis: true }
};

export const DATE_FILTER_PERIOD_KEYS = ['1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', 'MAX'];
export const DATE_FILTER_YEAR_PERIOD_KEYS = ['1Y', '2Y', '3Y', '4Y', '5Y', 'MAX'];

const DateFilterButtons = ({ selectedPeriod, onPeriodChange }) => {
  return (
    <div className="date-filter-buttons-container">
      <div className="date-filter-buttons">
        {DATE_FILTER_PERIOD_KEYS.map((periodKey) => (
          <button
            key={periodKey}
            className={`date-filter-btn ${selectedPeriod === periodKey ? 'active' : ''}`}
            onClick={() => onPeriodChange(periodKey)}
          >
            {PERIOD_CONFIG[periodKey].label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateFilterButtons;
